import api from "./api";

export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
  country: string;
  role: string;
  createdAt: string;
  updatedAt: string;
}

export const getUsers = async (): Promise<User[]> => {
  const response = await api.get("/admin/users");
  return response.data;
};
